export function sleep(t: number) {
  return new Promise<void>((resolve) => setTimeout(resolve, t));
}
